import { Box } from '@mui/material'

import { USER_ROLES } from '@/constants/userRoles'
import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { usePartnersQuery } from '@/features/partner/hooks/usePartnersQuery'
import { useSitesQuery } from '@/features/site/hooks/useSitesQuery'
import { PartnerUserForm } from '@/features/user/components/PartnerUserForm'
import { UserForm } from '@/features/user/components/UserForm'

export default function UserCreate() {
  const { loggedInUser } = useAuth()

  const { sites } = useSitesQuery()
  const { partners } = usePartnersQuery({ enabled: isCurrentUserAdmin() })

  function isCurrentUserAdmin() {
    return loggedInUser?.role === USER_ROLES.ADMINISTRATORS.value
  }

  function isCurrentUserPartnerAdmin() {
    return loggedInUser?.role === USER_ROLES.PARTNER_ADMINISTRATORS.value
  }

  if (!loggedInUser) {
    return null
  }

  return (
    <Box sx={{ marginY: 3 }}>
      {isCurrentUserAdmin() && <UserForm partners={partners ?? []} sites={sites ?? []} />}

      {isCurrentUserPartnerAdmin() && <PartnerUserForm sites={sites ?? []} />}
    </Box>
  )
}
